<template>
  <div class="login" v-if="withoutFlg">
    <div class="login-form">
      <div class="login-form-title">
        <img src="../../assets/icon-login-logo@2x.png" alt="" />
      </div>

      <a-form :form="form" @submit="handleSubmit">
        <template v-if="form">
          <a-form-item
            :validate-status="userNameError() ? 'error' : ''"
            :help="userNameError() || ''"
          >
            <a-input
              placeholder="账户"
              size="large"
              v-decorator="[
                'login',
                {
                  rules: [
                    {
                      required: true,
                      message: ' 请输入账号',
                    },
                  ],
                },
              ]"
            >
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0, 0, 0, 0.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item
            :validate-status="passwordError() ? 'error' : ''"
            :help="passwordError() || ''"
          >
            <a-input
              type="password"
              placeholder="密码"
              size="large"
              v-decorator="[
                'passwd',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入密码',
                      min: 6,
                      max: 12,
                    },
                  ],
                },
              ]"
            >
              <a-icon
                slot="prefix"
                type="lock"
                style="color: rgba(0, 0, 0, 0.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item v-if="errStatus">
            <a-alert :message="error" type="error" showIcon />
          </a-form-item>
          <a-form-item>
            <a-button
              size="large"
              block
              htmlType="submit"
              class="login-form-button"
              :disabled="hasErrors(form.getFieldsError())"
            >
              登 录
            </a-button>
          </a-form-item>
        </template>
      </a-form>
    </div>
    <div class="footer text-black-45">
      <div class="footer-top mb8">
        <span class="mr40">帮助中心</span>
        <span>意见反馈</span>
      </div>
      <div class="footer-bottom pb24">
        Copyright @ 2018 Zhe Technology Co., Ltd. 联系我们：0581-902930
      </div>
    </div>
  </div>
</template>
<script>
import { getUrl } from "@/strUrl";
export default {
  name: "login",
  data() {
    return {
      form: this.$form.createForm(this),
      errStatus: false,
      error: "1111",
      check: false,
      withoutFlg: false,
    };
  },
  components: {},
  methods: {
    hasErrors(fieldsError) {
      return Object.keys(fieldsError).some((field) => fieldsError[field]);
    },
    // Only show error after a field is touched.
    userNameError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("userName") && getFieldError("userName");
    },
    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },
    handleSubmit(e) {
      console.log("ee", e);
      e.preventDefault();
      localStorage.clear();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$api.login
            .login(values)
            .then((res) => {
                sessionStorage.removeItem("tongluSearchData");
                if (res.code > 0) {
                    this.$message.error(res.msg);
                } else {
                    localStorage.user = JSON.stringify(res.data);
                    localStorage._token = res.data.token;
                    this.$api.common.authority().then((res) => {
                    localStorage.authority = JSON.stringify(res.data.authority);
                    this.$eventBus.emit("updateRole");
                    const routes = this.$router.options.routes;
                    routes.forEach((it) => {
                        if (res.data.authority[0].name === it.meta.name) {
                        this.$router.push({ name: it.name });
                        }
                    });
                    });
                    // this.$router.push({
                    //     name: "account"
                    // });
                }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {});
        }
      });
    },

    // 免密登录
    withoutSay(verifyToken) {
      this.$api.login
        .govFreeLogin({
          verifyToken: decodeURIComponent(verifyToken.replace(/\%20/g, "%2B")),
        })
        .then((res) => {
          if (res.code > 0) {
            this.$message.error(res.msg);
          } else {
            localStorage.user = JSON.stringify(res.data);
            localStorage._token = res.data.token;
            this.$api.common.authority().then((res) => {
              localStorage.authority = JSON.stringify(res.data.authority);
              this.$eventBus.emit("updateRole");
              const routes = this.$router.options.routes;
              routes.forEach((it) => {
                if (res.data.authority[0].name === it.meta.name) {
                  this.$router.push({ name: it.name });
                }
              });
            });
            // this.$router.push({
            //     name: "account"
            // });
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
  },
  watch: {},
  created() {
    let _token = localStorage.getItem("_token");
    if (_token) {
      localStorage.clear();
    }

    setTimeout(() => {
      let obj = getUrl();
      if (obj == null) {
        this.withoutFlg = true;
      } else {
        this.withoutFlg = false;
        //   只允许verifyToken拼接在url后面，其他的参数拼接均为错误
        if (obj.verifyToken) {
          this.withoutSay(obj.verifyToken);
        } else {
          this.$message.error("错误参数");
        }

        return false;
      }
    }, 100);
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      if (this.withoutFlg) {
        this.form.validateFields();
      }
      // this.form.setFieldsValue({ login: '仓前分拣中心1' });
      // this.form.setFieldsValue({ passwd: 123456 });
    });
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.login {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: $background-color;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 26vh;

  &-form {
    width: 368px;

    &-title {
      color: $title-color-black-85;
      vertical-align: middle;
      margin-bottom: 61px;
    }
  }
  .ant-form-item-children {
    display: flex;
    justify-content: space-between;
  }
  .login-form-button {
    width: 100%;
    background: linear-gradient(to left, #086acc, #499df2);
    height: 40px;
    line-height: 40px;
    color: #fff;
  }
  .footer {
    position: absolute;
    bottom: 0;
    text-align: center;

    &-top {
      @include pxAndLh(14);
    }
    &-bottom {
      @include pxAndLh(12);
    }
  }
  .disabled {
    background: #f5f5f5;
    color: #b8b8b8;
  }
  .ant-alert-error {
    width: 100%;
  }
}

.ant-tooltip-inner {
  background: #fff;
  @include pxAndLh(14);
  .redText {
    color: $text-color-fail;
  }
}
</style>
